<template>
  <sdx-loading-spinner id="spinner-devAppDropDown" size="large" sr-hint="Loading. Please wait."
                       style="display: none"></sdx-loading-spinner>
  <sdx-select
      v-if="devAppsLoaded && devApps.length>0 && dropDownNeeded"
      data-testid="devAppDropDown"
      label="Application"
      placeholder="Choose an application..."
      keyboard-behavior="filter"
      filter-min-length="2"
      @input="devAppChanged"
      v-model="devAppWebId">
    <sdx-select-option
        v-for="devApp in devApps"
        data-testid="devAppDropDownOption"
        :key="devApp.webId"
        :value="devApp.webId"
        :selected="isSelectedDevApp(devApp.webId)"
    >{{ devApp.displayName }} <span class="product">({{ devApp.productPrettyName }})</span>
      <i>{{
          (devApp.ownerEmail != undefined && this.viewUserEmail === devApp.ownerEmail ? "" : " by " + devApp.ownerEmail)
        }}</i>
    </sdx-select-option>
  </sdx-select>

  <div class="row-cols noDropDown" id="noApplicationInfo" v-if="!dropDownNeeded">
    <sdx-input
        id="devApp1AppReadOnlyInput"
        label="Application"
        :value="devApps[0].displayName +' ('+devApps[0].productPrettyName +')'"
        readonly
    />
  </div>

  <div class="container" id="noApplicationInfo" v-if="devAppsLoaded && devApps.length<=0">
    <sdx-card
        id="devAppNoAppCard"
        layout="inline-notification"
        notification-type="warning"
        label="No application found"
        label-aria-level="3"
    >
      Seems you have no application for this product. Please subscribe to a Messaging API Product on <a
        href="https://digital.swisscom.com">Digital Marketplace</a>.
    </sdx-card>
  </div>
</template>

<script>
import loadingSpinnerService from '@/services/loading-spinner.service.js';
import devAppService from '@/services/dev-app.service';
import {logger} from "@/services/logger.service";
import userService from "@/services/user.service";

const EVENT_DEVAPP_CHANGED = "devapp-changed";

//Help for components: https://vuejs.org/guide/essentials/component-basics.html#listening-to-events
export default {
  props: {
    role: {
      type: String,
      required: true,
    },
    allSelectionEnabled: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    }
  },
  emits: [EVENT_DEVAPP_CHANGED],
  data() {
    return {
      devAppsLoaded: false,
      dropDownNeeded: true,
      devAppWebId: undefined,
      devApps: [],
      userEmail: ''
    };
  },
  mounted() {
    this.loadDevAppList();
    this.viewUserEmail= userService.getViewUserEmail()
  },
  methods: {
    getDevAppWebId() {
      return devAppService.getDevAppWebId(this.role);
    },
    async loadDevAppList() {
      loadingSpinnerService.show("devAppDropDown", "noApplicationInfo")
      try {
        this.devApps = await devAppService.getDevApps(this.role,this.allSelectionEnabled);
        this.devAppsLoaded = true;
        //preselection
        if (this.$route.query && this.$route.query.webId) {
          logger.debug("devAppRoute" + this.$route.query.webId);
          devAppService.setDevAppWebId(this.$route.query.webId, this.role);
          this.devAppWebId = this.$route.query.webId;
          this.notifyDevAppChanged();
        }
        this.dropDownNeeded = !(this.devApps.length === 1);
        if (this.dropDownNeeded) {
          logger.debug("Multi DevApps!! : " + this.devApps.length)
          const sessionDevWebAppId = this.getDevAppWebId();
          if (this.devApps !== undefined) {
            const existEntry = this.devApps.filter(function (el) {
              return el.webId == sessionDevWebAppId
            })
            if (existEntry !== undefined && existEntry.length > 0) {
              this.devAppWebId = sessionDevWebAppId;
              this.notifyDevAppChanged();
            } else {
              logger.debug("No Event, because entry not found in active list: " + this.devAppWebId)
            }
          } else {
            logger.debug("No Event, because devApps is empty.")
          }
        } else {
          logger.debug("Only 1 DevApp!! :" + this.devApps[0].displayName)
          devAppService.setDevAppWebId(this.devApps[0].webId, this.role);
          this.notifyDevAppChanged();
        }
      } catch (error) {
        this.devAppWebId = undefined
      }
      logger.debug("remove spinner!")
      loadingSpinnerService.hide("devAppDropDown", "noApplicationInfo");
    }
    ,
    async devAppChanged() {
      let webId = arguments[0].target.value;
      devAppService.setDevAppWebId(webId, this.role);
      this.notifyDevAppChanged();
    },
    notifyDevAppChanged() {
      logger.debug("notifyDevAppChanged", this.getDevAppWebId())
      this.$emit(EVENT_DEVAPP_CHANGED, this.getDevAppWebId())
    }
    ,
    isSelectedDevApp(webId) {
      return webId === devAppService.getDevAppWebId(this.role);
    }
    ,
  }
}
;
</script>

<style>
.product {
  color: #000033;
}

.noDropDown {
  border: 1px;
  border-color: black;
  border-radius: 8px;

}
</style>
